import React from "react";

export default function TypoTableHead() {
  return (
    <thead>
      <tr>
        <th></th>
        <th>Vekt</th>
        <th>Linjehøyde</th>
        <th>Mobil</th>
        <th>Desktop</th>
      </tr>
    </thead>
  );
}
